const ALLOWED_EXTENSIONS = ['mp3', 'mp4', 'mov']
const ALLOWED_MIME_TYPES = ['video/mp4', 'video/quicktime', 'audio/mpeg']

export const validateShotlistUploadFile = (file: File) => {
	const mime = file.type.toLowerCase()
	const ext = file.name.split('.').pop()?.toLowerCase()

	const validMime = ALLOWED_MIME_TYPES.includes(mime)
	const validExt = ext && ALLOWED_EXTENSIONS.includes(ext)

	if (mime && validMime) return true

	if (!mime && validExt) return true

	return false
}
